import React, { useContext, useEffect, useState } from 'react'
import { apiGet } from '../../../utils/apiFetch'
import apiPath from '../../../utils/apiPath'
import { AiFillEye, AiOutlineInfoCircle } from 'react-icons/ai'
import { useTranslation } from 'react-i18next'
import {
  BsArrowUpShort,
  BsHandThumbsDown,
  BsHandThumbsUp
} from 'react-icons/bs'
import AuthContext from 'context/AuthContext'
import { isEmpty, startCase } from 'lodash'
import helper from '../../../utils/helpers'
import Pagination from 'pages/Pagination'
import { NavLink } from 'react-router-dom'
import classNames from 'classnames'
import AcceptPropertyModal from './AcceptPropertyModal'
import RejectPropertyModal from './RejectPropertyModal'
import RejectedView from './RejectedView'

const PropertyApproval = ({ companyId, manager }) => {
  const [agent, setAgent] = useState([])
  const [page, setPage] = useState(1)
  const [item, setItem] = useState('')

  const [filterData, setFilterData] = useState({
    startDate: '',
    endDate: '',
    isReset: false,
    filterType: '',
    searchKey: '',
    category: ''
  })
  const [isAcceptProperty, setIsAcceptProperty] = useState(false)
  const [isRejectProperty, setIsRejectProperty] = useState(false)
  const [pageSize] = useState(10)
  const [isRejectedView, setIsRejectedView] = useState(false)
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })

  const [sort, setSort] = useState({
    sortKey: 'createdAt',
    sortType: 'desc'
  })
  const { t } = useTranslation()
  const { user } = useContext(AuthContext)

  const getApprovedProperties = async data => {
    try {
      const { category, searchKey } = filterData

      const payload = {
        page,
        pageSize,
        sortKey: sort.sortKey,
        sortType: sort.sortType,
        companyId,
        isApprovedStatus: category,
        keyword: searchKey
      }

      const path = apiPath.getPropertyApproval
      const result = await apiGet(path, payload)
      const response = result?.data?.results
      const resultStatus = result?.data?.success
      setAgent(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? response.page : null,
        pageCount: resultStatus ? response.totalPages : null,
        perPageItem: resultStatus ? response?.docs.length : null,
        totalItems: resultStatus ? response.totalDocs : null
      })
      // }
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message)
    }
  }
  const statusPage = e => {
    setFilterData({ ...filterData, category: e.target.value })
    setPage(1)
  }
  const handleChangeData = e => {
    // setKeyword(e.target.value)
    setFilterData({ ...filterData, searchKey: e.target.value, isFilter: true })
    setPage(1)
  }
  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }
  const handleReset = () => {
    setFilterData({
      startDate: '',
      endDate: '',
      isReset: false,
      filterType: '',
      searchKey: '',
      category: ''
    })
  }

  useEffect(() => {
    getApprovedProperties()
    // eslint-disable-next-line
  }, [page, sort, filterData])
  return (
    <>
      <div className='bg-white'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] '>
            <form className='border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3'>
              <div className='col-span-2 flex flex-wrap  items-center'>
                <div className='flex items-center lg:pt-0 pt-3 flex-wrap'>
                  {/* <ODateRangePicker
                    handleDateChange={handleDateChange}
                    isReset={filterData?.isReset}
                    setIsReset={setFilterData}
                  /> */}

                  <div className='flex items-center  ml-3 mb-3'>
                    <select
                      id=''
                      type='text '
                      name='category'
                      className='block p-2 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                      placeholder=' '
                      onChange={e => statusPage(e)}
                      value={filterData?.category}
                    >
                      <option defaultValue value=''>
                        {t('O_ALL')}
                      </option>
                      <option value='pending'>{t('O_PENDING')}</option>
                      <option value='accepted'>{t('ACCEPTED')}</option>
                      <option value='rejected'>{t('REJECTED')}</option>
                    </select>
                  </div>
                  <button
                    type='button'
                    onClick={handleReset}
                    className='bg-[#8FC150] text-sm px-8 ml-3 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] sm:w-auto w-1/2'
                  >
                    {t('O_RESET')}
                  </button>
                </div>
              </div>

              <div className='2xl:ml-auto xl:ml-0 lg:pt-0 pt-2'>
                <label
                  htmlFor='default-search'
                  className='mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white'
                >
                  {t('O_SEARCH')}
                </label>
                <div className='flex'>
                  <div className='relative '>
                    <div className='absolute inset-y-0 right-0 flex items-center pl-3 mr-3 pointer-events-none'>
                      <svg
                        aria-hidden='true'
                        className='w-4 h-4 text-[#A5A5A5] dark:text-gray-40'
                        fill='none'
                        stroke='currentColor'
                        viewBox='0 0 24 24'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        {!filterData?.searchKey && (
                          <path
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth='2'
                            d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
                          />
                        )}
                      </svg>
                    </div>
                    <input
                      type='search'
                      id='default-search'
                      title=''
                      className='block w-full p-2 outline-none text-sm text-gray-900 2xl:min-w-[300px] xl:min-w-[300px] rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                      placeholder={t('SEARCH_BY_KEYWORD')}
                      value={filterData?.searchKey}
                      required
                      onChange={e => handleChangeData(e)}
                    />
                  </div>
                </div>
              </div>
            </form>
            <div className='p-3'>
              <div className='overflow-x-auto relative 
 border'>
                <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
                  <thead className='text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
                    <tr>
                      <th scope='col' className='py-3 px-6 text-center'>
                        #
                      </th>
                      <th
                        scope='col'
                        className='py-3 px-6 cursor-pointer'
                        onClick={() => {
                          if (
                            sort.sortKey === 'name' &&
                            sort.sortType === 'asc'
                          ) {
                            setSort({
                              sortKey: 'name',
                              sortType: 'desc'
                            })
                          } else {
                            setSort({
                              sortKey: 'name',
                              sortType: 'asc'
                            })
                          }
                        }}
                      >
                        <div className='flex'>
                          <span>{t('O_PROPERTY_ID')} </span>
                          <span>
                            {sort.sortKey === 'name' &&
                              sort.sortType === 'asc' && (
                                <BsArrowUpShort className='w-4 h-4' />
                              )}
                            {sort.sortKey === 'name' &&
                              sort.sortType === 'desc' && (
                                <BsArrowUpShort className='w-4 h-4 rotate-180' />
                              )}
                          </span>
                        </div>
                      </th>

                      <th
                        scope='col'
                        className='py-3 px-6 cursor-pointer'
                        onClick={() => {
                          setSort(prevSort => ({
                            sortKey: 'email',
                            sortType:
                              prevSort.sortKey === 'email' ? 'desc' : 'asc'
                          }))
                        }}
                      >
                        <div className='flex'>
                          <span>{t('O_PROPERTY_TITLE')} </span>
                          <span>
                            {sort.sortKey === 'email' &&
                              sort.sortType === 'asc' && (
                                <BsArrowUpShort className='w-4 h-4' />
                              )}
                            {sort.sortKey === 'email' &&
                              sort.sortType === 'desc' && (
                                <BsArrowUpShort className='w-4 h-4 rotate-180' />
                              )}
                          </span>
                        </div>
                      </th>

                      <th
                        scope='col'
                        className='py-3 px-6 cursor-pointer'
                        onClick={() => {
                          setSort(prevSort => ({
                            sortKey: 'email',
                            sortType:
                              prevSort.sortKey === 'email' ? 'desc' : 'asc'
                          }))
                        }}
                      >
                        <div className='flex'>
                          <span>{t('PROPERTY_TYPE')}</span>
                          <span>
                            {sort.sortKey === 'email' && (
                              <BsArrowUpShort
                                className={`w-4 h-4 ${
                                  sort.sortType === 'desc' ? 'rotate-180' : ''
                                }`}
                              />
                            )}
                          </span>
                        </div>
                      </th>
                      <th scope='col' className='py-3 px-6 cursor-pointer'>
                        {t('PROPERTY_CATEGORY')}
                      </th>

                      <th
                        scope='col'
                        className='py-3 px-6 cursor-pointer'
                        onClick={() => {
                          if (
                            sort.sortKey === 'email' &&
                            sort.sortType === 'asc'
                          ) {
                            setSort({
                              sortKey: 'email',
                              sortType: 'desc'
                            })
                          } else {
                            setSort({
                              sortKey: 'email',
                              sortType: 'asc'
                            })
                          }
                        }}
                      >
                        <div className='flex'>
                          <span>{t('O_AGENT_NAME')} </span>
                          <span>
                            {sort.sortKey === 'email' &&
                              sort.sortType === 'asc' && (
                                <BsArrowUpShort className='w-4 h-4' />
                              )}
                            {sort.sortKey === 'email' &&
                              sort.sortType === 'desc' && (
                                <BsArrowUpShort className='w-4 h-4 rotate-180' />
                              )}
                          </span>
                        </div>
                      </th>

                      <th scope='col' className='py-3 px-6 '>
                        {t('COMPANY_NAME')}
                      </th>
                      <th
                        scope='col'
                        className='py-3 px-6 cursor-pointer '
                        onClick={() => {
                          if (
                            sort.sortKey === 'listedOn' &&
                            sort.sortType === 'asc'
                          ) {
                            setSort({
                              sortKey: 'listedOn',
                              sortType: 'desc'
                            })
                          } else {
                            setSort({
                              sortKey: 'listedOn',
                              sortType: 'asc'
                            })
                          }
                        }}
                      >
                        <div className='flex '>
                          <span>{t('O_CREATED_AT')} </span>
                          <span>
                            {sort.sortKey === 'listedOn' &&
                              sort.sortType === 'asc' && (
                                <BsArrowUpShort className='w-4 h-4' />
                              )}
                            {sort.sortKey === 'listedOn' &&
                              sort.sortType === 'desc' && (
                                <BsArrowUpShort className='w-4 h-4 rotate-180' />
                              )}
                          </span>
                        </div>
                      </th>
                      {/* <th scope='col' className='py-3 px-6 '>
                        {t('O_STATUS')}
                      </th> */}
                      <th
                        scope='col'
                        className='py-3 px-6 cursor-pointer '
                        onClick={() => {
                          setSort(prevSort => ({
                            sortKey: 'updatedAt',
                            sortType:
                              prevSort.sortKey === 'updatedAt' &&
                              prevSort.sortType === 'asc'
                                ? 'desc'
                                : 'asc'
                          }))
                        }}
                      >
                        <div className='flex '>
                          {t('O_STATUS')}
                          {sort.sortKey === 'updatedAt' &&
                            sort.sortType === 'asc' && (
                              <BsArrowUpShort className='w-4 h-4' />
                            )}
                          {sort.sortKey === 'updatedAt' &&
                            sort.sortType === 'desc' && (
                              <BsArrowUpShort className='w-4 h-4 rotate-180' />
                            )}
                        </div>
                      </th>

                      <th scope='col' className='py-3 px-6 text-center'>
                        {t('O_ACTION')}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      agent?.map((item, i) => (
                          <tr
                            key={i}
                            className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'
                          >
                            <th
                              scope='row'
                              className='py-2 px-2 text-center border-r font-medium text-gray-900  dark:text-white'
                            >
                              {i + 1 + 10 * (paginationObj?.page - 1)}
                            </th>
                            <td className='py-2 px-2 border-r'>
                              {item?.propertyId}{' '}
                            </td>
                            <td className='py-2 px-2 border-r'>
                              {item?.title}
                            </td>
                            <td className='py-2 px-2 border-r'>
                              {item?.propertytype?.name || 'N/A'}
                            </td>
                            <td className='py-2 px-2 border-r'>
                              {item?.propertyCategory?.name || 'N/A'}
                            </td>
                            <td className='py-2 px-2 border-r'>
                              {' '}
                              {item?.agent?.firstName
                                ? startCase(item?.agent?.firstName) +
                                  ' ' +
                                  startCase(item?.agent?.lastName)
                                : 'N/A'}
                            </td>
                            <td className='py-2 px-2 border-r '>
                            {item?.company?.name ? startCase(item?.company?.name) : item?.agent?.parentType ==='admin'? 'Mada Properties':'Freelancer'}
                            </td>
                            <td className='py-2 px-2 border-r'>
                              {helper.dateFormat(item?.listedOn)}
                            </td>

                            {/* <td className='py-2 px-2 border-r '>
                      {item?.agentName || 'N/A'}
                    </td> */}

                            {/* <td className='py-2 px-2 border-r '>
                            {startCase(item?.isApprovedStatus)}
                          </td> */}
                            {(manager?.add ||
                              user?.permission?.length === 0) && (
                              <>
                                <td className='py-2 px-2 border-r text-center'>
                                  {item?.isApprovedStatus === 'pending' && (
                                    <>
                                      <button
                                        title={t('O_ACCEPT')}
                                        type='button'
                                        onClick={() => {
                                          setIsAcceptProperty(true)
                                          setItem(item)
                                        }}
                                        className='animate-bounce text-lg border border-transparent text-green-600 hover:text-green-900'
                                      >
                                        <BsHandThumbsUp />
                                      </button>
                                      <button
                                        title={t('O_REJECT')}
                                        type='button'
                                        onClick={() => {
                                          // helper.alertFunction(
                                          // 	'Are you sure you want to reject the request?',
                                          // 	{
                                          // 		_id: item?._id,
                                          // 		status: 'rejected',
                                          // 	},
                                          // 	handelStatusChange
                                          // )
                                          setIsRejectProperty(true)
                                          setItem(item)
                                        }}
                                        className='animate-bounce text-lg border border-transparent text-red-600 hover:text-red-900'
                                      >
                                        <BsHandThumbsDown />
                                      </button>
                                    </>
                                  )}

                                  {item?.isApprovedStatus !== 'pending' && (
                                    //    <div className="flex justify-between items-center">

                                    // 	</div>
                                    <>
                                      <div>
                                        <span
                                          className={classNames('', {
                                            'text-green-600':
                                              item?.isApprovedStatus ===
                                              'accepted',
                                            'text-red-600':
                                              item?.isApprovedStatus ===
                                              'rejected'
                                          })}
                                        >
                                          {startCase(item?.isApprovedStatus)}
                                        </span>
                                        {item?.isApprovedStatus ===
                                          'rejected' && (
                                          <span
                                            className=' pl-2 cursor-pointer text-right'
                                            onClick={() => {
                                              setIsRejectedView(true)
                                              setItem(item)
                                            }}
                                          >
                                            <AiOutlineInfoCircle className='inline w-6 h-6 text-yellow-400' />
                                          </span>
                                        )}
                                      </div>
                                    </>
                                  )}
                                </td>
                              </>
                            )}
                            <td className='py-2 px-2 border-l'>
                              <div className=''>
                                <ul className='flex justify-center'>
                                  <NavLink
                                    to={`/properties/view/${item._id}`}
                                    state={{
                                      item,
                                      propertyId: item?._id,
                                      tab: 'property_approval'
                                    }}
                                    className='px-2 py-2 hover:bg-white hover:text-LightBlue cursor-pointer'
                                  >
                                    <AiFillEye className=' w-5 h-5 text-slate-600' />{' '}
                                  </NavLink>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        ))}
                    {isEmpty(agent) && (
                      <tr className='bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700'>
                        <td className='py-2 px-2' colSpan={12}>
                          {t('O_NO_RECORD_FOUND')}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {paginationObj?.totalItems > 0 && (
        <Pagination
          handlePageClick={handlePageClick}
          options={paginationObj}
          page={page}
        />
      )}
      {isAcceptProperty && (
        <AcceptPropertyModal
          setIsAcceptProperty={setIsAcceptProperty}
          item={item}
          getApprovedProperties={getApprovedProperties}
        />
      )}
      {isRejectProperty && (
        <RejectPropertyModal
          setIsRejectProperty={setIsRejectProperty}
          item={item}
          getApprovedProperties={getApprovedProperties}
        />
      )}
      {isRejectedView && (
        <RejectedView setIsRejectedView={setIsRejectedView} item={item} />
      )}
    </>
  )
}

export default PropertyApproval
